import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { TaskStatusFindInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-find.dto';
import type { TaskFindInterface } from '@zaoblako/shared/modules/task/dtos/task-find.dto';
import { TaskStatusTypeEnum } from '@zaoblako/shared/modules/task/enum/task.status.type.enum';
import { TaskStatusStateService } from '@zaoblako/web/modules/payments/services/task-status-state.service';
import { StatusLabelComponent } from '@zaoblako/web/shared/components/status-label/status-label.component';
import { OrderByPipe } from '@zaoblako/web/shared/pipes/order-by.pipe';
import { Observable } from 'rxjs';

@Component({
  selector: 'crm-selected-tasks-possible-statuses',
  standalone: true,
  imports: [CommonModule, StatusLabelComponent, OrderByPipe],
  templateUrl: './selected-tasks-possible-statuses.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectedTasksPossibleStatusesComponent {
  public readonly statusInfo: Partial<Record<TaskStatusTypeEnum, string>> = {
    DRAFT: 'В заполнение',
    SCHEDULED: 'Запланировать',
    ON_APPROVAL: 'На согласование',
    AGREED: 'Согласовать'
  };

  @Input() public selectedTasks: TaskFindInterface[] = [];
  @Output() public changeStatus = new EventEmitter<TaskStatusFindInterface>();

  public get selectedTasksPossibleStatuses(): Observable<TaskStatusFindInterface[]> {
    return this.taskStatusStateService.getTasksPossibleStatuses(this.selectedTasks);
  }

  public constructor(private readonly taskStatusStateService: TaskStatusStateService) {}
}
